import { Button, Container } from '@mui/material';
import { NavLink } from "react-router-dom";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import MaterialPriceDetailsForm from '../../forms/materialPriceDetailsForm';
import { Icons } from '../../icons';


const MaterialPriceAdd = () => {
	const userContext = useUserContext();

	return (
		<div className="hwi-material-price-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageMaterialPrices}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/materialprice">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Material Price
						</div>
					</section>
					<section className="management-page-form">
						<MaterialPriceDetailsForm></MaterialPriceDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default MaterialPriceAdd;